import { t } from '@lingui/core/macro';
export const getLockedReasonMessage = (lockedReason) => {
    if (lockedReason === 'ESIGNING:CREATING' ||
        lockedReason === 'ESIGNING:PENDING' ||
        lockedReason === 'ESIGNING:CANCELLED') {
        return t({
            comment: 'Download document dialog - Download unavailable - eSigning pending',
            message: 'Downloading this document as a DOCX file is not available while the document is sent for eSigning.',
        });
    }
    if (lockedReason === 'ESIGNING:SIGNED') {
        return t({
            comment: 'Download document dialog - Download unavailable - eSigning signed',
            message: 'Downloading this document as a DOCX file is not available after the document has been signed.',
        });
    }
    return undefined;
};
/**
 *
 * @description This function will wrap the html in a div with the class "ck-content".
 *
 * @example wrapHtml('<h2>Title</h2>') // <div class="ck-content"><h2>Title</h2></div>
 */
export const wrapHtml = (html) => `<div class="ck-content">${html}</div>`;
